import { getResponseParseService } from 'services/ResponseParseService'
import { makeSpinRequest } from 'services/ServerService'
import { signal } from 'services/SignalsService'
import { debug } from 'settings/custom/build'

const name = 'REQUEST-SPIN'

async function execute() {
  signal.dispatch(`SOUND:spin-btn:${game.models.ModeModel.turbo}`)

  const lines = game.models.SpinModel.get().lines

  let action = 'spin'

  const freeBetModel = game.models.FreebetsModel.get()
  if (freeBetModel.isFreeBet) {
    action = game.models.ResponseDataModel.get().action
  }

  const response = await makeRequest({
    action: action,
    token: game.models.GameModel.token,
    params: {
      bet: game.models.BetModel.getValue() / lines,
      lines,
    },
    platform: game.models.GameModel.platform,
    m: game.models.GameModel.m,
  })

  if (!game.models.GameModel.requestAgainAllowed) {
    if (response && response.status.ok) {
      getResponseParseService().parse(response)
    }
  }
}

function makeRequest(data) {
  if (debug) {
    return makeSpinRequest(shift(data))
  }
  else {
    return makeSpinRequest(data)
  }
}

export function getRequestSpinAction() {
  return {
    name,
    execute,
  }
}

//---------------------------------------------------------------

const cheats = []

if (debug) {
  Object.assign(window, { clear, cheat })
}

export function cheat(value) {
  const checkAction = value.includes(';')
  if (checkAction) {
    return cheats.push(value)
  }

  const spinModel = game.models.SpinModel.get()
  value = value.toUpperCase()
  const rows = value.split(',')
  if (rows.length > 1) {
    return cheats.push(rows.join(''))
  }
  const [a, b] = value.split(':')
  const line = b ? a : '1'
  const symbols = Array.from(b || a)
  const path = spinModel.paths[line]
  const blank = spinModel.reelSymbols.slice().reverse()
  const matrix = []
  for (let j = 0; j < spinModel.height; j++) {
    for (let i = 0; i < spinModel.width; i++) {
      matrix.push(j == path[i][1] && symbols[i] ? symbols[i] : blank[i])
    }
  }
  return cheats.push(matrix.join(''))
}

export function clear() {
  return (cheats.length = 0)
}

function shift(data) {
  if (cheats.length) {
    data.params.cheats = cheats.shift()
  }
  return data
}
